/*
 * Copyright (c) 2025, Wultra s.r.o. (www.wultra.com).
 *
 * All rights reserved. This source code can be used only for purposes specified
 * by the given license contract signed by the rightful deputy of Wultra s.r.o.
 * This source code can be used only by the owner of the license.
 *
 * Any disputes arising in respect of this agreement (license) shall be brought
 * before the Municipal Court of Prague.
 */

import type { JSX } from "react"

import { formatRole, UserRole } from "../../features/user/user-types"
import { SelectFilter } from "../ui-widgets/filter/select-filter"

interface RoleMultiSelectorProps {
    selectedRoles: string[]
    onChange: (roles: string[]) => void
}

export function RoleMultiSelector({ selectedRoles, onChange }: RoleMultiSelectorProps): JSX.Element {
    const availableRoles = Object.values(UserRole).filter((role) => !selectedRoles.includes(role))

    return (
        <div>
            <SelectFilter
                label="Roles:"
                options={availableRoles.map((role) => ({ label: formatRole(role), value: role }))}
                value={null}
                onChange={(selected) => {
                    if (selected && !selectedRoles.includes(selected)) {
                        onChange([...selectedRoles, selected])
                    }
                }}
                noSelectionLabel="Select a role..."
            />

            {selectedRoles.length > 0 && (
                <div className="flex flex-wrap gap-2 mb-2">
                    {selectedRoles.map((role) => (
                        <span key={role} className="badge bg-legacy-primary flex items-center">
                            {formatRole(role)}
                            <button
                                type="button"
                                className="btn-close btn-close-white ms-2"
                                style={{ fontSize: "0.6rem" }}
                                onClick={() => onChange(selectedRoles.filter((r) => r !== role))}
                            ></button>
                        </span>
                    ))}
                </div>
            )}
        </div>
    )
}
